import { render, staticRenderFns } from "./PersonalizationImages.vue?vue&type=template&id=154d663e&scoped=true"
import script from "./PersonalizationImages.vue?vue&type=script&lang=js"
export * from "./PersonalizationImages.vue?vue&type=script&lang=js"
import style0 from "./PersonalizationImages.vue?vue&type=style&index=0&id=154d663e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154d663e",
  null
  
)

export default component.exports